$('[data-toggle]').on('click', (e) => {
  e.preventDefault();
  const selector = $(e.target).data('toggle');
  if($(selector).css('display') === 'none') {
    $(selector).show();
  } else {
    $(selector).removeAttr('style').hide();
  }
});
